import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import MissingPinPrompt from "@/components/MissingPinPrompt";
import AdminSecurityNotice from "@/components/AdminSecurityNotice";
import AdDetail from "@/pages/AdDetail";
import Footer from "@/components/Footer";
import WhatsAppHelp from "@/components/WhatsAppHelp";
import ScrollToTop from "@/components/ScrollToTop";
import GreenTheme from "@/components/GreenTheme";
import Home from "@/pages/Home";
import SearchResults from "@/pages/SearchResults";
import ProductDetail from "@/pages/ProductDetail";
import ShopDetail from "@/pages/ShopDetail";
import ServiceDetail from "@/pages/ServiceDetail";
import PublicVendorProfile from "@/pages/PublicVendorProfile";
import CategoryPage from "@/pages/CategoryPage";
import VendorDashboard from "@/pages/VendorDashboard";
import AdminPanel from "@/pages/AdminPanel";
import ProfilePage from "@/pages/ProfilePage";
import NotificationsPage from "@/pages/NotificationsPage";
import Onboarding from "@/pages/Onboarding";
import PublicActivityProfile from "@/pages/PublicActivityProfile";
import LanguagePrompt from "@/components/LanguagePrompt";
import MaintenanceGate from "@/components/MaintenanceGate";
import PinReminder from "@/components/PinReminder";
import SharedAdReport from "@/pages/SharedAdReport";
import LocationShareDetail from "@/pages/LocationShareDetail";
import "@/App.css";

function App() {
  return (
    <div className="App flex flex-col min-h-screen">
      <AppProvider>
        <BrowserRouter>
          <ScrollToTop />
          <GreenTheme />
          <MaintenanceGate>
          <Header />
          <AdminSecurityNotice />
          <LanguagePrompt />
          <PinReminder />
          <MissingPinPrompt />
          <main className="flex-1 min-h-[70vh]">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/search" element={<SearchResults />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/service/:id" element={<ServiceDetail />} />
              <Route path="/shop/:id" element={<ShopDetail />} />
              <Route path="/v/:slug" element={<PublicVendorProfile />} />
              <Route path="/vendor/:slug" element={<PublicVendorProfile />} />
              <Route path="/category/:type" element={<CategoryPage />} />
              <Route path="/vendor" element={<VendorDashboard />} />
              <Route path="/admin" element={<AdminPanel />} />
              <Route path="/orders" element={<Navigate to="/" replace />} />
              <Route path="/orders/:id" element={<Navigate to="/" replace />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/location-share/:id" element={<LocationShareDetail />} />
              <Route path="/onboarding" element={<Onboarding />} />
              <Route path="/p/:id" element={<PublicActivityProfile />} />
              <Route path="/r/:token" element={<SharedAdReport />} />
              <Route path="/ad/:id" element={<AdDetail />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppHelp />
          </MaintenanceGate>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
